import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './ResearchCooperation.module.scss';
import { PatentStatItem } from '../type';

/**
 * 专利统计卡片组件
 * 展示单条专利统计数据，如“超过 9700 件 美团专利布局”
 */
const PatentStatCard: FC<PatentStatItem> = (props) => {
  const { prefix, value, unit, description } = props;

  return (
    <div className={styles['patent-stat-card']}>
      <div className={styles['patent-stat-value-row']}>
        {prefix && <span className={styles['patent-stat-prefix']}>{prefix}</span>}
        <span className={classNames('mt-font', styles['patent-stat-value'])}>{value}</span>
        {unit && <span className={styles['patent-stat-unit']}>{unit}</span>}
      </div>
      <div className={styles['patent-stat-desc']}>{description}</div>
    </div>
  );
};

PatentStatCard.displayName = 'PatentStatCard';
export default PatentStatCard;
